/**
 * Curated ethnicity options.
 *
 * Broad regional/cultural groupings — NOT national identity (that's
 * `nationalityIso`). Users may select multiple to express mixed
 * heritage. Avoid politically-loaded sub-groupings; we keep the list
 * broad and let users tell their specific story via the bio prompts.
 *
 * No icons here — the chip-list display is text-only for cultural
 * groupings (an icon would risk reducing identity to a flag emoji).
 */

import type { TraitOption } from '../types.js';

export const ETHNICITY_OPTIONS: readonly TraitOption[] = [
  { value: 'south_asian', labelKey: 'ethnicity.south_asian' },
  { value: 'east_asian', labelKey: 'ethnicity.east_asian' },
  { value: 'south_east_asian', labelKey: 'ethnicity.south_east_asian' },
  { value: 'central_asian', labelKey: 'ethnicity.central_asian' },
  { value: 'middle_eastern', labelKey: 'ethnicity.middle_eastern' },
  { value: 'arab', labelKey: 'ethnicity.arab' },
  { value: 'turkic', labelKey: 'ethnicity.turkic' },
  { value: 'persian', labelKey: 'ethnicity.persian' },
  { value: 'kurdish', labelKey: 'ethnicity.kurdish' },
  { value: 'north_african', labelKey: 'ethnicity.north_african' },
  { value: 'west_african', labelKey: 'ethnicity.west_african' },
  { value: 'east_african', labelKey: 'ethnicity.east_african' },
  { value: 'southern_african', labelKey: 'ethnicity.southern_african' },
  { value: 'european', labelKey: 'ethnicity.european' },
  { value: 'balkan', labelKey: 'ethnicity.balkan' },
  { value: 'caucasian_north_american', labelKey: 'ethnicity.caucasian_north_american' },
  { value: 'african_american', labelKey: 'ethnicity.african_american' },
  { value: 'latin_american', labelKey: 'ethnicity.latin_american' },
  { value: 'caribbean', labelKey: 'ethnicity.caribbean' },
  { value: 'mixed', labelKey: 'ethnicity.mixed' },
  { value: 'other', labelKey: 'ethnicity.other' },
] as const;

export const ETHNICITY_VALUES: ReadonlySet<string> = new Set(ETHNICITY_OPTIONS.map((o) => o.value));
